import type { AppState } from './types';

export const selectStep = (state: AppState) => {
  return state.steps.at(-1) ?? null;
};

/**
 * Returns the BFF-issued step payload for a given step identifier (e.g. multirange
 * `challengeSequence`, NFC `challenge`). Components keyed off the step name read
 * this from context and pass it down.
 */
export const selectStepData = (state: AppState, stepKey: string): Record<string, unknown> | undefined => {
  return state.stepData[stepKey];
};
